import { api } from '@shared/config/axiosConfig';
import { buildEndpoint } from '@shared/utils/buildEndpoint';
import { coverageConfigCreateToDto, coverageConfigFromDto, coverageConfigUpdateToDto, coverageFromDto } from '@/features/quotations/mappers/coverageConfigMapper';
import { validateRequiredFields } from '@/shared/utils/validateRequiredFields';

const BASE_ENDPOINT = 'coverage-configs';

const buildServiceEndpoint = ({ id, action } = {}) => {
  return buildEndpoint(BASE_ENDPOINT, { id, action });
};

export const getCoverageConfigs = async (data = {}) => {
  const params = {
    agreement_plan: data.planId,
    active: data.active,  // Opcional. Si no se proporciona, se retornan todas las coberturas 
  };

  const endpoint = buildServiceEndpoint();
  const response = await api.get(endpoint, { params });
  return response.data.map(coverageConfigFromDto);
};

export const getAvailableCoverages = async () => {
  const endpoint = buildServiceEndpoint({ action: 'available-coverages' });
  const response = await api.get(endpoint);
  return response.data.map(coverageFromDto);
};

export const createCoverageConfig = async (data) => {
  const payload = coverageConfigCreateToDto(data);
  const endpoint = buildServiceEndpoint();
  const response = await api.post(endpoint, payload);
  return coverageConfigFromDto(response.data);
};

export const updateCoverageConfig = async (id, data) => {
  validateRequiredFields({ id });

  const payload = coverageConfigUpdateToDto(data);
  const endpoint = buildServiceEndpoint({ id });
  const response = await api.put(endpoint, payload);
  return coverageConfigFromDto(response.data);
};

/** El endpoint responde con un código 204 (No Content), por lo que no se retorna ningún valor. */
export const deleteCoverageConfig = async (id) => {
  validateRequiredFields({ id });

  const endpoint = buildServiceEndpoint({ id });
  await api.delete(endpoint);
};
